import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import plShared from '../locales/pl/shared.json';
import plLanding from '../locales/pl/landing.json';
import plDiscover from '../locales/pl/discover.json';
import plEvents from '../locales/pl/events.json';
import plNotifications from '../locales/pl/notifications.json';
import plProfile from '../locales/pl/profile.json';

import enShared from '../locales/en/shared.json';
import enLanding from '../locales/en/landing.json';
import enDiscover from '../locales/en/discover.json';
import enEvents from '../locales/en/events.json';
import enNotifications from '../locales/en/notifications.json';
import enProfile from '../locales/en/profile.json';

const resources = {
  pl: {
    shared: plShared,
    landing: plLanding,
    discover: plDiscover,
    events: plEvents,
    notifications: plNotifications,
    profile: plProfile,
  },
  en: {
    shared: enShared,
    landing: enLanding,
    discover: enDiscover,
    events: enEvents,
    notifications: enNotifications,
    profile: enProfile,
  },
};

i18n
  .use(LanguageDetector) // Wykrywa język przeglądarki
  .use(initReactI18next) // Przekazuje i18n do react-i18next
  .init({
    resources,
    fallbackLng: 'pl', // Domyślny język jeśli wykryty język nie jest dostępny
    lng: 'pl', // Język startowy
    debug: false, // Włącz w development jeśli chcesz debugować

    // Namespaces (podział tłumaczeń na pliki)
    ns: ['shared', 'landing', 'discover', 'events', 'notifications', 'profile'],
    defaultNS: 'shared',
    // Bezpieczny fallback w trakcie migracji komponentów (żeby stare useTranslation() dalej działało)
    fallbackNS: ['shared', 'landing', 'discover', 'events', 'notifications', 'profile'],
    
    interpolation: {
      escapeValue: false, // React już escapuje wartości
    },

    detection: {
      // Kolejność wykrywania języka
      order: ['localStorage', 'navigator'],
      // Klucz w localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache wybranego języka
      caches: ['localStorage'],
    },
  });

export default i18n;






